import { createContext } from 'react';

import type { TrackingFunctions } from '../types/Analytics';
import type { AnalyticsSettings } from './types';

export interface AnalyticsProxyCtx extends TrackingFunctions {
  initialize: (settings?: Partial<AnalyticsSettings>) => void;
  trackingEnabled: boolean;
  debuggingEnabled: boolean;
}

const AnalyticsProxyContext = createContext<AnalyticsProxyCtx | undefined>(undefined);

export default AnalyticsProxyContext;
